import apiClient from '@/lib/api-client';

export interface ModuleActivity {
  activity_id: string;
  type: 'lesson' | 'exercise' | 'session' | 'quiz' | 'assignment';
  title: string;
}

export interface ModuleSection {
  section_id: string;
  name: string;
  order: number;
  delivery_method: 'e-learning' | 'live-online' | 'offline';
  activities: ModuleActivity[];
}

export interface ModuleVersion {
  version: string;
  status: 'Draft' | 'Published' | 'Archived';
  published_at: string;
}

export interface Module {
  id: string;
  module_id: string;
  name: string;
  module_code: string;
  description: string;
  status: 'Draft' | 'Published' | 'Archived';
  delivery_methods: ('e-learning' | 'live-online' | 'offline')[];
  current_version: string;
  updated_at: string;
  created_at?: string;
  subject: string;
  tags: string[];
  sections_count: number;
  sections?: ModuleSection[];
  versions?: ModuleVersion[];
}

export interface ApiResponse<T> {
  success: boolean;
  data: T;
  message: string;
  count: number;
}

export interface ModuleSearchParams {
  status?: string;
  delivery_method?: string;
  search?: string;
}

const moduleApi = {
  getModules: async (): Promise<ApiResponse<Module[]>> => {
    const response = await apiClient.get('/module');
    return response.data;
  },

  getModule: async (id: string): Promise<ApiResponse<Module>> => {
    const response = await apiClient.get(`/module/${id}`);
    return response.data;
  },

  searchModules: async (params: ModuleSearchParams): Promise<ApiResponse<Module[]>> => {
    const response = await apiClient.post('/module/search', params);
    return response.data;
  },

  createModule: async (moduleData: Partial<Module>): Promise<ApiResponse<Module>> => {
    const response = await apiClient.post('/module', moduleData);
    return response.data;
  },

  updateModule: async (id: string, moduleData: Partial<Module>): Promise<ApiResponse<Module>> => {
    const response = await apiClient.put(`/module/${id}`, moduleData);
    return response.data;
  },

  deleteModule: async (id: string): Promise<ApiResponse<void>> => {
    const response = await apiClient.delete(`/module/${id}`);
    return response.data;
  }
};

export default moduleApi; 